import type { SpinnerTheme } from '../../components/primitives/spinner'
import { baseColors } from '../dwa-base'

const spinnerTheme: SpinnerTheme = {
  spinner: [
    {
      style: {
        flexDirection: 'row',
        justifyContent: 'center',
        borderRadius: 60,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: baseColors.grey2,
        borderTopColor: baseColors.blue,
      },
    },
    {
      decoration: 'secondary',
      style: { borderColor: baseColors.red, borderTopColor: baseColors.white },
    },
    {
      decoration: 'command',
      style: {
        borderColor: baseColors.white,
        borderTopColor: baseColors.blue2,
      },
    },
    {
      decoration: 'danger-secondary',
      style: { borderColor: baseColors.red, borderTopColor: baseColors.white },
    },
    {
      decoration: 'danger',
      style: { borderColor: baseColors.red, borderTopColor: baseColors.white },
    },
  ],
}
export default spinnerTheme
